import styled from 'styled-components';
import { motion, useScroll, useSpring, useTransform } from 'framer-motion';
import { PropsWithChildren, useRef } from 'react';

export default function HistorySection() {
  return (
    <Container>
      <Wrapper>
        <Content>
          <HistoryOf2023>
            <YearAndDot>
              <Year>2023</Year>
              <Dot $background="#00BED6">
                <Line />
                <OuterDot />
              </Dot>
            </YearAndDot>
            <HistoryList>
              <HistoryItem>
                <Month>12월</Month>
                <History>청소연구소 앱 누적 다운로드 315만 건</History>
              </HistoryItem>
              <HistoryItem>
                <Month>10월</Month>
                <History>매니저 12만명 돌파</History>
              </HistoryItem>
            </HistoryList>
          </HistoryOf2023>

          <HistoryOfYear>
            <YearAndDot>
              <Year>2022</Year>
              <Dot $background="#8CCCD5" />
            </YearAndDot>
            <HistoryList>
              <HistoryItem>
                <Month>8월</Month>
                <History>포브스 아시아 100대 유망 기업 선정</History>
              </HistoryItem>
              <HistoryItem>
                <Month>8월</Month>
                <History>청소연구소 앱 누적 다운로드 270만 건</History>
              </HistoryItem>
              <HistoryItem>
                <Month>7월</Month>
                <History>생활용품 전문몰, &apos;청연플러스샵&apos; 오픈</History>
              </HistoryItem>
              <HistoryItem>
                <Month>5월</Month>
                <History>사무실청소 서비스 오픈</History>
              </HistoryItem>
            </HistoryList>
          </HistoryOfYear>
          <HistoryOfYear>
            <YearAndDot>
              <Year>2021</Year>
              <Dot $background="#8CCCD5" />
            </YearAndDot>
            <HistoryList>
              <HistoryItem>
                <Month>6월</Month>
                <History>청소연구소 앱 누적 다운로드 170만 건</History>
              </HistoryItem>
              <HistoryItem>
                <Month>6월</Month>
                <History>제5기 신용보증기금 혁신아이콘 기업 선정</History>
              </HistoryItem>
              <HistoryItem>
                <Month>5월</Month>
                <History>220억원 투자 유치 (시리즈 C)</History>
              </HistoryItem>
            </HistoryList>
          </HistoryOfYear>
          <HistoryOfYear>
            <YearAndDot>
              <Year>2019</Year>
              <Dot $background="#8BCCD5" />
            </YearAndDot>
            <HistoryList>
              <HistoryItem>
                <Month>8월</Month>
                <History>성남시 청년고용우수기업 선정</History>
              </HistoryItem>
              <HistoryItem>
                <Month>5월</Month>
                <History>100억원 투자 유치 (시리즈 B)</History>
              </HistoryItem>
            </HistoryList>
          </HistoryOfYear>
          <HistoryOfYear>
            <YearAndDot>
              <Year>2018</Year>
              <Dot $background="#A7D2D7" />
            </YearAndDot>
            <HistoryList>
              <HistoryItem>
                <Month>1월</Month>
                <History>25억원 투자 유치 (시리즈 A)</History>
              </HistoryItem>
            </HistoryList>
          </HistoryOfYear>
          <HistoryOfYear>
            <YearAndDot>
              <Year>2017</Year>
              <Dot $background="#B8D6DA" />
            </YearAndDot>
            <HistoryList>
              <HistoryItem>
                <Month>4월</Month>
                <History>10억원 투자 유치 (시드 투자)</History>
              </HistoryItem>
              <HistoryItem>
                <Month>2월</Month>
                <History>집청소 서비스, &apos;청소연구소&apos; 앱 출시</History>
              </HistoryItem>
              <HistoryItem>
                <Month>1월</Month>
                <History>생활연구소 창업</History>
              </HistoryItem>
            </HistoryList>
          </HistoryOfYear>
        </Content>
      </Wrapper>
    </Container>
  );
}

const HistoryItem = ({ children }: PropsWithChildren<{}>) => {
  const ref = useRef<HTMLLIElement>(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['end end', 'start start'],
  });
  const opacity = useSpring(useTransform(scrollYProgress, [0, 0.001], [0, 1]));

  return (
    <HistoryWrapper ref={ref} style={{ opacity }}>
      {children}
    </HistoryWrapper>
  );
};

const Container = styled.section`
  width: 100%;
  padding: 0 24px;
  padding-top: 30px;
  padding-bottom: 200px;
  background: #e9f7f8;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    padding-bottom: 65px;
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    padding-top: 24px;
    padding-bottom: 29px;
  }
`;

const Wrapper = styled.div`
  position: relative;
  margin: 0 auto;
  max-width: ${({ theme }) => theme.brandSitesV2!.containerWidths!.desktop};

  /* @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) { */
  max-width: ${({ theme }) => theme.brandSitesV2!.containerWidths!.tablet};
  /* } */

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    /* max-width: ${({ theme }) => theme.brandSitesV2!.containerWidths!.mobile}; */
  }
`;

const Content = styled.div`
  background: #ffffff;
  border-radius: 16px;
  padding: 90px 102px;
  overflow: hidden;

  /* @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) { */
  padding: 62px 70px;
  /* } */

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    border-radius: 8px;
    padding: 30px 4px 30px 29px;
  }
`;

const YearAndDot = styled.div`
  display: flex;
  flex-direction: row;
  line-height: 100%;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    flex-direction: row-reverse;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 12px;
  }
`;

const Year = styled.span`
  font-weight: 600;
  font-size: 40px;

  width: 100px;
  margin-right: 30px;

  /* @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) { */
  font-size: 27px;
  width: 68px;
  margin-right: 22px;
  /* } */

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    font-size: 16px;
    margin-right: 0;
  }
`;

const Dot = styled.div<{ $background?: string }>`
  position: relative;
  width: 20px;
  height: 20px;
  background: ${({ $background }) => $background || '#00bed6'};
  border-radius: 100%;
  margin-right: 48px;

  /* @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) { */
  width: 14px;
  height: 14px;
  margin-right: 32px;
  /* } */

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    width: 8px;
    height: 8px;
    margin-right: 16px;
  }
`;

const OuterDot = styled.div`
  position: absolute;
  width: 40px;
  height: 40px;
  background: #bceef4;
  border-radius: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  &::before {
    content: '';
    position: relative;
    position: absolute;
    width: 20px;
    height: 20px;
    background: #00bed6;
    border-radius: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  /* @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) { */
  width: 28px;
  height: 28px;

  &::before {
    width: 14px;
    height: 14px;
  }
  /* } */

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    width: 16px;
    height: 16px;

    &::before {
      width: 8px;
      height: 8px;
    }
  }
`;

const Line = styled.div`
  position: absolute;
  left: 50%;
  top: 100%;
  transform: translateX(-50%);
  width: 1px;
  height: 1000px;
  background: linear-gradient(180deg, #00bed6 -8.51%, rgba(154, 160, 163, 0.26) 103.05%);

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    background: linear-gradient(180deg, #00bed6 -8.51%, rgba(154, 160, 163, 0.26) 103.05%);
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    background: linear-gradient(180deg, #00bed6 -8.51%, rgba(154, 160, 163, 0.13) 97.71%);
  }
`;

const HistoryList = styled.ol`
  list-style: none;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    margin-left: 24px;
  }
`;

const HistoryWrapper = styled(motion.li)`
  display: flex;
  flex-direction: row;
  line-height: 100%;
  margin-bottom: 40px;

  /* @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) { */
  margin-bottom: 28px;
  /* } */

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    margin-bottom: 16px;
  }
`;

const Month = styled.span`
  font-weight: 400;
  font-size: 28px;
  color: #939393;
  white-space: nowrap;
  margin-right: 14px;

  /* @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) { */
  font-size: 20px;
  /* } */

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    font-size: 14px;
    margin-right: 6px;
  }
`;

const History = styled.p`
  font-weight: 300;
  font-size: 28px;

  /* @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) { */
  font-size: 20px;
  /* } */

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    font-size: 14px;
    font-weight: 400;
  }
`;

const HistoryOfYear = styled.div`
  display: flex;
  margin-bottom: 54px;

  /* @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) { */
  margin-bottom: 36px;
  /* } */

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    flex-direction: column;
    margin-bottom: 16px;
  }

  &:last-child {
    margin-bottom: 0;
  }
`;

const HistoryOf2023 = styled(HistoryOfYear)`
  ${Month} {
    color: #00bed6;
  }
`;
